export const CURTAIN_ANIMATION = {
  TRANSITION_FRAMES: 10, // Frames for final fade transition
  OPACITY_FADE_RATIO: 0.2, // Ratio of duration for opacity fade-in
  OVERLAP_PERCENT: 1.0, // Column overlap to close gaps
} as const;

export const UNFOLD_EASING = [0.25, 0.46, 0.45, 0.94] as const; // Bezier curve for smooth unfold

export const CLIP_PATHS = {
  FIRST_COLUMN: 'inset(0 0 0 -50%)', // Extra left bleed for notch
  DEFAULT_COLUMN: 'inset(0)',
  CONTAINER: 'inset(0 0 0 -2px)', // Container with left bleed
} as const;
